;(function() {

  $(document).ready(function() {
    $('.js-example-basic-single').select2();
  });

}());

;(function() {

	/*	Code for validate only numbers
	*	Table with KEY-codes: https://keycode.info/
	*	8 - backspace/delete
	*	0 - key has no keycode
	*	13 - enter
	*	e < 48 || e > 57 - NOT NUMBERS
	*/

	$('.js-only-numbers').on('keypress', function(e) {
		if (e.which != 8 && e.which != 0 && e.which != 13 && (e.which < 48 || e.which > 57)) {
			return false;
		}
	});


	/* add max value for numeric input  */

	$('[data-max-val]').on('input', function(e) {
		let maxVal = Number($(this).attr('data-max-val') || 99);

		if ($(this).val() > maxVal) {
			$(this).val(maxVal);
		}
	})

}());


;(function() {

	/*
	* <a href="#footer" class="js-anchor-link">scroll to...</a>
	*/

	$('.js-anchor-link').on('click', function(e) {
		e.preventDefault();

		let linkedSection = $($(this).attr('href'));

		if (linkedSection.length > 0) {
			$('html, body').animate({
				scrollTop: linkedSection.offset().top
			}, 500)
		}
	});

}());
;(function() {
	let accordionContainer = $('.js-accordion-container')
	let accordionToggler = $('.js-accordion-toggler');

	if (accordionToggler.length < 1) {
		return;
	}

	/*
	* accordionContainer - use it, if you need add one event listener , instead not for all accordions togglers
	* accordionToggler - accordion title, icon on some thing else.
	* accordion - accordion item container
	* accordionContent - content which animated
	*/

	if (accordionContainer.length) {
		accordionContainer.on('click', '.js-accordion-toggler', toggleAccordion);
	} else {
		accordionToggler.click(toggleAccordion);
	}

	function toggleAccordion() {
		let accordion = $(this).parents('.js-accordion');
		let accordionContent = accordion.find('.js-accordion-content');

		accordion.toggleClass('open');
		accordionContent.stop().slideToggle(400, function() {
			$(this).css('height', '');
		});
	}
}());
;(function() {
	/* Custom Events */

	$(document).on('popup:open', function(e, popup, popupId) {
		console.log(popupId, ' POPUP is open');
	});

	$(document).on('popup:close', function(e, popup, popupId) {
		console.log(popupId, ' POPUP is close');
		bodyScrollLock.clearAllBodyScrollLocks();
	});




	/* Custom POPUP */

	let popupLinks = $('.js-open-popup');
	let popupOpenClass = 'popup--open';
	let popupCloseButton = $('.js-close-popup');


	popupLinks.on('click', function(e) {
		e.preventDefault();

		let popupId = $(this).attr('data-popup-id');
		let popup = $('#' + popupId);
		let youtubeLink = $(this).attr('data-popup-youtube');

		if (popup.length < 1) {
			console.log('Popup not found');
			return;
		}

		if (youtubeLink) {
			let youtubeVideoId = youtube_id_parser(youtubeLink);

			console.log(youtubeVideoId);
			let iframe = `	<div class="popup__iframe-wrapper">
								<iframe
									src="https://www.youtube.com/embed/${youtubeVideoId}?enablejsapi=1&controls=1&fs=1&iv_load_policy=3&autoplay=1&mute=0&rel=0&showinfo=0&loop=0&start=0"
									frameborder="0"
									allow="autoplay"
									allowfullscreen
								>
								</iframe>
							</div>
						 `;

		 	$(document).trigger('popup:open', [popup, popupId]);

			popup.find('.popup__content').append(iframe);

			popup.addClass(popupOpenClass);
			bodyScrollLock.disableBodyScroll(popup[0]);

		} else {
			$(document).trigger('popup:open', [popup, popupId]);

			popup.addClass(popupOpenClass);
			bodyScrollLock.disableBodyScroll(popup[0]);
		}
	});

	popupCloseButton.on('click', function(e) {
		let popup = $(this).parents('.js-popup');
		let popupId = popup.attr('id');

		$(document).trigger('popup:close', [popup, popupId]);
		popup.removeClass(popupOpenClass);

		if (popup.find('.popup__iframe-wrapper').length > 0) {
			popup.find('.popup__iframe-wrapper').remove();
		}
	});


	function youtube_id_parser(url){
		/* Return the youTube video ID */

		var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		var match = url.match(regExp);
		return (match&&match[7].length==11)? match[7] : false;
	}

}());
;(function() {
	/*
	*
	*	Lazy load images script with CACHE check.
	*	If images in cache - lazy load would not start.
	*
	*	If you don't need a feature with caches image - comment code.
	*
	*	HTML basic structure
	*	<picture class="lazy">
	*		<source data-srcset="img-src-for-1x-screen 1x, img-src-for-2x-screen 2x" >
	*		<img src="img-src-thumbnail-40x-resolution" data-srcset="img-src-default-resolution" srcset="img-src-thumbnail-40x-resolution" alt="">
	*	</picture>
	*/

	document.addEventListener("DOMContentLoaded", function (event) {
		if (window.caches) {
			var lazyImages = [].slice.call(
				document.querySelectorAll(".lazy [data-srcset]")
				);

			Promise.all(lazyImages.map(img => {
				const src = img.getAttribute('data-srcset');

				return window.caches.match(src).then(response => {
					if (response) {
						img.setAttribute('srcset', src);
						img.removeAttribute('data-srcset');
						img.parentElement.classList.remove("lazy");
					}
				})
			})).then(lazyLoadPictures);
		} else {
			lazyLoadPictures();
		}

		function lazyLoadPictures() {
			var lazyImages = [].slice.call(
				document.querySelectorAll(".lazy [data-srcset]")
				);

			if (lazyImages.length < 1) {
				return;
			}

			if ("IntersectionObserver" in window) {
				let lazyImageObserver =
				new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							let lazyImage = entry.target;
							lazyImage.srcset = lazyImage.dataset.srcset;

							caches.open('images').then(function(cache) {
								cache.addAll([lazyImage.dataset.srcset]).then(function() {});
							});

							lazyImage.parentElement.classList.remove("lazy");
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				});

				lazyImages.forEach(function (lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});
			} else {
			// Not supported, load all images immediately
				lazyImages.forEach(function (image) {
					image.srcset = image.dataset.srcset;
				});
			}
		}
	});
}());
;(function() {
  const parent = jQuery('body');
  const barParent = jQuery('.js-bar');
  const barParentClose = barParent.find('.js-bar-close');
  const barActive = 'hide';
  const barParentActive = 'with-out-bar';
  const notify = () => {
    if(sessionStorage.getItem('showAnnouncementBar') === 'false') {
      barParent.addClass(barActive);
      parent.addClass(barParentActive);
    }
  };

  barParentClose.on('click', function() {
    sessionStorage.setItem('showAnnouncementBar', 'false');
    notify();
  });

  notify();
}());

;(function() {
  jQuery('.navigation__item').each(function() {
    var item = jQuery(this);
    var drop = item.find('.main-drop');
    var link = item.find('a').eq(0);
    if (drop.length) {
      item.addClass('has-drop');
      if (link.length) link.addClass('has-drop-a');
    }
  });

  jQuery('.navigation__item').each(function() {
    var item = jQuery(this);
    var drop = item.find('.second-nav');
    var link = item.find('a').eq(0);
    if (drop.length) {
      item.addClass('has-drop');
      if (link.length) link.addClass('has-drop-a');
    }
  });

  jQuery('.second-nav__item').each(function() {
    var item = jQuery(this);
    var drop = item.find('.third-nav');
    var link = item.find('a').eq(0);
    if (drop.length) {
      item.addClass('has-subdrop');
      if (link.length) link.addClass('has-subdrop-a');
    }
  });
}());
;(function() {
  const drops = $('.navigation__item--full-drop');
  drops.each(function () {
    let dropCounter = $(this).find('.column-counter').text();
    let hasImages = $(this).find('.only_images-column').text();

    $(this).find('.main-drop__holder').addClass(`main-drop__columns-${dropCounter}`);
    if(hasImages == 'true') {
      $(this).addClass(`navigation__item--only-images`);
      $(this).removeClass(`has-drop`);
    }
  });
}());

;(function() {

  jQuery('.js-toggle-item').openClose({
    activeClass: 'active',
    opener: '.js-toggle-button',
    slider: '.js-toggle-content',
    animSpeed: 400,
    hideOnClickOutside: false,
    effect: 'slide'
  });

  ResponsiveHelper.addRange({
    '..1024': {
      on: function() {
        jQuery('.has-drop').openClose({
          activeClass: 'active',
          opener: '.navigation__open-drop',
          slider: '.second-nav',
          animSpeed: 400,
          hideOnClickOutside: true,
          effect: 'slide'
        });

        jQuery('.has-subdrop').openClose({
          activeClass: 'active',
          opener: '.third-nav__open-drop',
          slider: '.third-nav',
          animSpeed: 400,
          effect: 'slide'
        });

        jQuery('.navigation__item--full-drop.has-drop').openClose({
          activeClass: 'active',
          opener: '.navigation__open-drop',
          slider: '.main-drop',
          animSpeed: 400,
          hideOnClickOutside: true,
          effect: 'slide'
        });

        jQuery('.main-drop__column-menu').openClose({
          activeClass: 'active-new',
          opener: '.drop-menu__title',
          slider: '.drop-menu',
          animSpeed: 400,
          effect: 'slide'
        });
      },
      off: function() {
        jQuery('.has-drop').openClose('destroy');
        jQuery('.navigation__item--full-drop.has-drop').openClose('destroy');
        jQuery('.has-subdrop').openClose('destroy');
        jQuery('.main-drop__column-menu').openClose('destroy');
      }
    }
  });

}());

// openClose menu init
;(function() {
  jQuery('body').mobileNav({
    menuActiveClass: 'search-active',
    menuOpener: '.js-search--opener',
    hideOnClickOutside: true,
    menuDrop: '.header__search-form'
  });

  jQuery('body').mobileNav({
    menuActiveClass: 'menu-active',
    menuOpener: '.js-menu--opener',
    hideOnClickOutside: true,
    menuDrop: '.navigation-wrap'
  });
}());

;(function() {
  const searchOpener = $('.js-search--mobile-opener');
  searchOpener.on('click', function() {
    // const searchOverlay = $('.bc-sf-search-suggestion-mobile-overlay');
    // const searchPanel = $('.bc-sf-search-suggestion-mobile-top-panel');
    const searchOverlay = $('.boost-pfs-search-suggestion-mobile-overlay');
    const searchPanel = $('.boost-pfs-search-suggestion-mobile-top-panel');
    searchOverlay.show();
    searchPanel.show();
  });
}());
function addComparePrise() {
  const cartItemParent = jQuery('.js-minicart-item');

  if(cartItemParent.length < 1){return};

  cartItemParent.each(function() {
    const item = jQuery(this);
    const cartItem = item.find('.js-compare');
    const cartItemSaleText = item.find('[data-sale-text]');
    const cartItemPrice = item.find('.js-price').attr('data-minicart-price');
    const cartItemFullUrl = cartItem.attr('data');
    const cartItemUrl = cartItemFullUrl.split('?')[0];
    const cartItemVariant = cartItemFullUrl.split('?')[1].split('=')[1];

    const itemQty = item.find('[data-item-qty]').val();
    const itemBtnPlus = item.find('.qty-number--plus');
    const message = item.find('[data-limit-message]');
    const labels = item.find('[data-label-list]');
    const labelSale = labels.attr('data-sale-text');
    const labelLimit = labels.attr('data-limit-text');
    let labelList = '';

    labels.addClass('hide');
    cartItem.addClass('hide');
    message.addClass('hide');
    cartItemSaleText.addClass('hide');
    jQuery.getJSON(cartItemUrl + '.js', function(product) {

      if(product.url !== cartItemUrl){return};

      jQuery(product.tags).each(function() {
        if (this.indexOf("pfs:label") !== -1 && this.indexOf("final") === -1) {
          var tagLabel = this.split('pfs:label-')[1].toLowerCase();
          var tagLabelHandle = tagLabel.replace(/\s/ig, '-')
          labelList += `<span class="cart-table__label-list-item label-${tagLabelHandle}">${tagLabel}</span>`;
        }

        if (this.indexOf("pfs:label") !== -1 && this.indexOf("final") !== -1) {
          cartItemSaleText.removeClass('hide');
        }

        if (this.indexOf("pfs:label") !== -1 && this.indexOf("final") !== -1) {
          labels.addClass('hide-sale');
        }
      });

      jQuery(product.variants).each(function() {
        if(this.id == cartItemVariant && cartItemPrice < this.compare_at_price) {
          labelList += `<span class="cart-table__label-list-item label-sale">${labelSale}</span>`;
          cartItem.html(Shopify.formatMoney(this.compare_at_price));
          cartItem.removeClass('hide');
        }

        if(this.id == cartItemVariant) {
          fetch(`${cartItemUrl}?view=json`, {
            redirect: 'follow',
            credentials: 'include'
          }).then((response) => {
            response.json().then(function(parsedJson) {
              jQuery(parsedJson.option).each(function() {

                let variant = Number.parseInt(cartItemVariant);
                if(this[variant]) {
                  if(this[variant] < 5) {
                    labelList += `<span class="cart-table__label-list-item label-limit">${labelLimit}</span>`;
                  }
                  if(this[variant] == itemQty) {
                    message.removeClass('hide');
                    itemBtnPlus.addClass('btn-disabled');
                  } else {
                    itemBtnPlus.removeClass('btn-disabled');
                  }
                }

              });
              labels.html(labelList);
            })
          });
        }
      });

      labels.removeClass('hide');
    });
  });
}

function reload() {
  location.reload();
}

function nostoBlockFunction() {
  const nostoButtons = jQuery('.atc-button');

  jQuery(nostoButtons).on('click', function() {
      setTimeout(reload, 2500);
  });
}

;(function() {
  const miniCartTrigger = jQuery('[data-mini-cart-trigger]');
  const miniCartActive = 'mini-cart--shown';
  const miniCartParent = jQuery('[data-mini-cart]');
  const cartCount = jQuery('[data-cart-count]');
  const cartTotal = jQuery('[data-cart-total]');
  const cartFull = jQuery('[data-full-cart-content]');
  const cartEmpty = jQuery('[data-empty-cart-content]');

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    cartCount.html(cart.item_count);
    cartTotal.html(Shopify.formatMoney(cart.items_subtotal_price));

    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }

    if (cart.item_count === 0) {
      cartCount.addClass('hide');
      cartFull.addClass('hide');
      cartEmpty.removeClass('hide');
    } else {
      cartCount.removeClass('hide');
      cartFull.removeClass('hide');
      cartEmpty.addClass('hide');
    }

    addComparePrise();
  });

  jQuery(document).on('input', '[data-variant]', function() {
    var $this = jQuery(this);
    CartJS.updateItem(Number.parseInt($this.attr('data-variant')), Number.parseInt($this.val()));
  });

  function addMiniCartTrigger(e) {
    e.preventDefault();
    miniCartParent.toggleClass(miniCartActive);
  }

  miniCartTrigger.click(addMiniCartTrigger);
  setTimeout(addComparePrise, 1000);

  let intervalID = window.setInterval(loadNosto, 100);

  function loadNosto() {
    const buttons = jQuery('.atc-button');
    if(buttons.length > 0) {
      nostoBlockFunction();
      clearInterval(intervalID)
    }
  }

}());

;(function() {
  jQuery('.js-validation').formValidation({
    errorClass: 'input--error'
  });


  jQuery('.js-site-footer__form').formValidation({
    errorClass: 'input--error'
  });
}());

;(function() {
  const searchFocus = document.querySelector('[data-search-focus]');
  const searchFocusTarget = document.querySelector('[data-search-focus-target]');

  var focusInput = function () {
    searchFocusTarget.focus();
  };

  searchFocus.addEventListener('click', focusInput);
}());

